export default "__VITE_ASSET__CJAq1AaW__"